<app-production-schedule-status-icon
  [withNewIcons]="withNewIcons"
  [withSmallSize]="withSmallSize"
  [status]="productionScheduleStatus"
  [state]="productionScheduleState"
></app-production-schedule-status-icon>
